import { useCallback, useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { toast } from "sonner";

const PAGES = [
    { key: "home", label: "Homepage (/)" },
    { key: "servicos", label: "Serviços (/servicos)" },
    { key: "como-trabalhamos", label: "Como Trabalhamos (/como-trabalhamos)" },
    { key: "codigo-h", label: "Código H. (/codigo-h)" },
    { key: "sobre-nos", label: "Quem Somos (/sobre-nos)" },
    { key: "contactos", label: "Contactos (/contactos)" },
    { key: "orcamento", label: "Pedido de orçamento (/orcamento)" },
    { key: "trabalhos", label: "Trabalhos (/trabalhos)" },
];

export default function AdminSEO() {
    const [pageKey, setPageKey] = useState("home");
    const [seo, setSeo] = useState({});
    const [all, setAll] = useState([]);

    const loadAll = useCallback(() => api.get("/admin/seo").then(r => setAll(r.data)), []);
    useEffect(() => { loadAll(); }, [loadAll]);

    useEffect(() => {
        const found = all.find(s => s.page === pageKey);
        setSeo(found || { title: "", description: "", og_title: "", og_description: "", og_image_id: "", slug: "" });
    }, [pageKey, all]);

    const save = async () => {
        try {
            await api.put(`/admin/seo/${pageKey}`, seo);
            toast.success("SEO guardado");
            loadAll();
        } catch { toast.error("Erro"); }
    };

    const uploadImg = async (file) => {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/upload", fd);
        return data.id;
    };

    return (
        <div className="max-w-3xl">
            <h1 className="font-display text-3xl font-bold text-stone-900 mb-6">SEO</h1>
            <label className="block mb-6">
                <span className="text-xs uppercase tracking-wider text-stone-500 block mb-1">Página</span>
                <select value={pageKey} onChange={(e) => setPageKey(e.target.value)} className="w-full border border-stone-300 rounded p-2" data-testid="seo-page">
                    {PAGES.map(p => <option key={p.key} value={p.key}>{p.label}</option>)}
                </select>
            </label>
            <div className="bg-white border border-stone-200 rounded-xl p-6 space-y-4">
                <Field label="Title (máx ~60 caracteres)" v={seo.title} on={(v) => setSeo({...seo, title: v})} k="seo-title" />
                <Field label="Meta description (máx ~160 caracteres)" v={seo.description} on={(v) => setSeo({...seo, description: v})} area k="seo-desc" />
                <Field label="Open Graph title" v={seo.og_title} on={(v) => setSeo({...seo, og_title: v})} k="seo-og-title" />
                <Field label="Open Graph description" v={seo.og_description} on={(v) => setSeo({...seo, og_description: v})} area k="seo-og-desc" />
                <div>
                    <label className="text-xs uppercase tracking-wider text-stone-500 block mb-1">Open Graph image</label>
                    {seo.og_image_id && <img src={fileUrl(seo.og_image_id)} alt="" className="w-40 rounded mb-2" />}
                    <input type="file" accept="image/*" onChange={async (e) => { if (e.target.files[0]) { const id = await uploadImg(e.target.files[0]); setSeo({...seo, og_image_id: id}); }}} />
                </div>
                <button onClick={save} data-testid="seo-save" className="btn-copper !py-2 !px-4 text-sm">Guardar SEO desta página</button>
            </div>
        </div>
    );
}

function Field({ label, v, on, area, k }) {
    return (
        <label className="block">
            <span className="text-xs uppercase tracking-wider text-stone-500 block mb-1">{label}</span>
            {area
                ? <textarea rows={3} value={v || ""} onChange={(e) => on(e.target.value)} className="w-full border border-stone-300 rounded p-2 text-sm" data-testid={k} />
                : <input value={v || ""} onChange={(e) => on(e.target.value)} className="w-full border border-stone-300 rounded p-2 text-sm" data-testid={k} />
            }
        </label>
    );
}
